// import { createSlice } from "@reduxjs/toolkit";

// const timesheetSlice = createSlice({
//   name: "timesheet",
//   initialState: {
//     loading: false,
//     error: null,
//     timesheets: [],
//     totalCount: {},
//     currentTimesheetUiid: null,
//     currentTimesheet: {
//       details: {},
//       loadedTabs: [],
//     },
//     timeSheetDashboard:{

//     }
//   },
//   reducers: {
//     clearTimesheetData(state) {
//       state.timesheets = [];
//       state.totalCount = {};
//       state.currentTimesheetUiid = null;
//       state.currentTimesheet = {
//         details: {},
//         loadedTabs: [],
//       };
//     },
//     clearTimesheetProfile(state) {
//       state.currentTimesheetUiid = null;
//       state.currentTimesheet = {
//         details: {},
//         loadedTabs: [],
//       };
//     },
//     setTimesheetProfile(state, action) {
//       state.currentTimesheet.details = {
//         ...state.currentTimesheet.details,
//         ...action.payload,
//       };
//     },
//     getTimesheetsStart(state, action) {
//       state.loading = true;
//     },
//     getTimesheetsSuccess(state, action) {
//       state.loading = false;
//       state.timesheets = action.payload.data;
//       state.totalCount = action.payload.totalCount;
//     },
//     getTimesheetsFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     addTimesheetStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     addTimesheetSuccess(state, action) {
//       state.currentTimesheetUiid = action.payload.data.uiid;
//       state.loading = false;
//     },
//     addTimesheetFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     updateTimesheetStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     updateTimesheetSuccess(state, action) {
//       state.loading = false;
//     },
//     updateTimesheetFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     getTimesheetOneStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     getTimesheetOneSuccess(state, action) {
//       state.loading = false;
//       state.currentTimesheetUiid =
//         action.payload.data.uiid || state.currentTimesheetUiid;
//       state.currentTimesheet.details = {
//         ...state.currentTimesheet.details,
//         ...action.payload.data,
//       };
//     },
//     getTimesheetOneFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//       state.currentTimesheet = {
//         details: {},
//         loadedTabs: [],
//       };
//     },
//     resetCurrentTimesheet(state) {
//       state.currentTimesheet = {
//         details: {},
//         loadedTabs: [],
//       };
//     },
//     getTimeSheetsDashboardStart(state,action){
//       state.timeSheetDashboard={}
//     },
//     successTimeSheetsDasboardStart(state,action){
//       state.timeSheetDashboard=action.payload
//     }
//   },
// });

// export const {
//   getTimesheetsStart,
//   getTimesheetsSuccess,
//   getTimesheetsFailure,
//   addTimesheetStart,
//   addTimesheetSuccess,
//   addTimesheetFailure,
//   updateTimesheetStart,
//   updateTimesheetSuccess,
//   updateTimesheetFailure,
//   getTimesheetOneStart,
//   getTimesheetOneSuccess,
//   getTimesheetOneFailure,
//   clearTimesheetData,
//   clearTimesheetProfile,
//   resetCurrentTimesheet,
//   setTimesheetProfile,
//   getTimeSheetsDashboardStart,
//   successTimeSheetsDasboardStart,
// } = timesheetSlice.actions;

// export default timesheetSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const timesheetSlice = createSlice({
  name: "timesheet",
  initialState: {
    loading: false,
    error: null,
    timesheets: {},
    totalCount: {},
    currentTimesheetUiid: null,
    currentTimesheet: {
      details: {},
      loadedTabs: [],
    },
    timeSheetDashboard: {},
  },
  reducers: {
    clearTimesheetData(state) {
      state.timesheets = {};
      state.totalCount = {};
      state.currentTimesheetUiid = null;
      state.currentTimesheet = {
        details: {},
        loadedTabs: [],
      };
    },
    clearTimesheetProfile(state) {
      state.currentTimesheetUiid = null;
      state.currentTimesheet = {
        details: {},
        loadedTabs: [],
      };
    },
    setTimesheetProfile(state, action) {
      state.currentTimesheet.details = {
        ...state.currentTimesheet.details,
        ...action.payload,
      };
    },
    getTimesheetsStart(state, action) {
      state.loading = true;
    },
    getTimesheetsSuccess(state, action) {
      state.loading = false;
      state.timesheets = action?.payload?.data || {
        data: [],
      };
      state.totalCount = action.payload.totalCount;
    },
    getTimesheetsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.timesheets = {};
    },
    addTimesheetStart(state) {
      state.loading = true;
      state.error = null;
    },
    addTimesheetSuccess(state, action) {
      state.currentTimesheetUiid = action.payload.data.uiid;
      state.loading = false;
      state.error = null;
    },
    addTimesheetFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateTimesheetStart(state) {
      state.loading = true;
      state.error = null;
    },
    updateTimesheetSuccess(state, action) {
      state.loading = false;
    },
    updateTimesheetFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getTimesheetOneStart(state) {
      state.loading = true;
      state.error = null;
    },
    getTimesheetOneSuccess(state, action) {
      state.loading = false;
      state.currentTimesheetUiid =
        action.payload.data.uiid || state.currentTimesheetUiid;
      state.currentTimesheet.details = {
        ...state.currentTimesheet.details,
        ...action.payload.data,
      };
    },
    getTimesheetOneFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.currentTimesheet = {
        details: {},
        loadedTabs: [],
      };
    },
    resetCurrentTimesheet(state) {
      state.currentTimesheet = {
        details: {},
        loadedTabs: [],
      };
    },
    getTimeSheetsDashboardStart(state, action) {
      state.loading = true;
      state.error = null;
      state.timeSheetDashboard = {};
    },
    successTimeSheetsDasboardStart(state, action) {
      state.loading = false;
      state.timeSheetDashboard = action.payload;
    },
    failureTimeSheetsDasboardStart(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetTimeSheetsDashboard(state) {
      state.timeSheetDashboard = {};
    },
  },
});

export const {
  getTimesheetsStart,
  getTimesheetsSuccess,
  getTimesheetsFailure,
  addTimesheetStart,
  addTimesheetSuccess,
  addTimesheetFailure,
  updateTimesheetStart,
  updateTimesheetSuccess,
  updateTimesheetFailure,
  getTimesheetOneStart,
  getTimesheetOneSuccess,
  getTimesheetOneFailure,
  clearTimesheetData,
  clearTimesheetProfile,
  resetCurrentTimesheet,
  setTimesheetProfile,
  getTimeSheetsDashboardStart,
  successTimeSheetsDasboardStart,
  failureTimeSheetsDasboardStart,
  resetTimeSheetsDashboard,
} = timesheetSlice.actions;

export default timesheetSlice.reducer;
